var openBetLanguages = {
  'de-de': 'de-de',
  'el-gr': 'el',
  'en-gb': 'en-gb',
  'es-es': 'es-es',
  'fr-fr': 'fr-fr',
  'it-it': 'it',
  'ja-jp': 'ja',
  'pl-pl': 'pl',
  'ru-ru': 'ru',
  'sv-se': 'sv',
  'zh-cn': 'zh-cn',
  'zh-hk': 'zh-hk'
};

var getEnvPostfix = function getEnvPostfix(env) {
  return !env || env === 'prod' ? '' : "-".concat(env);
};

var getOpenBetDeviceType = function getOpenBetDeviceType(isMobile) {
  return isMobile ? 'mob' : 'acc';
};

var getOpenBetLanguage = function getOpenBetLanguage(language) {
  return openBetLanguages[language] || language;
};

var getDepositHtmlPageName = function getDepositHtmlPageName(userFlow) {
  return userFlow === 'registration' ? 'post_register' : 'deposit';
};

export var getDefaultActionData = function getDefaultActionData(_ref) {
  var data = _ref.data,
      config = _ref.config,
      context = _ref.context;

  if (typeof data !== 'string') {
    return undefined;
  }

  var env = config.env,
      language = config.language,
      regSource = config.regSource,
      isMobile = config.isMobile;

  var _ref2 = context || {},
      _ref2$userFlow = _ref2.userFlow,
      userFlow = _ref2$userFlow === void 0 ? '' : _ref2$userFlow;

  return data.replace('{lang}', language).replace('{regSource}', regSource).replace('{env}', getEnvPostfix(env)).replace('{obLang}', getOpenBetLanguage(language)).replace('{obDevice}', getOpenBetDeviceType(isMobile)).replace('{depositHtmlPage}', getDepositHtmlPageName(userFlow));
};
//# sourceMappingURL=defaultData.js.map